<script>
import ChildMoodRepository from '../../js/repository/ChildMoodRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
        month: {
            type: Number,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ChildMoodRepository.findForChildAndMonth,
                params: [this.childId, this.month, this.year],
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
